const THUMBSTRIP_WIDTH = 90;
const THUMBSTRIP_HEIGHT = 50;
const MAX_CANVAS_HEIGHT = 10000; // Limit to prevent browser crash

export const generateVideoThumbstrip = (src) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement("video");
        video.src = src;
        video.crossOrigin = "anonymous";

        video.onloadedmetadata = () => {
            const { duration } = video;

            let thumbstripFrames = Math.min(Math.ceil(duration), Math.ceil(duration / 60) * 60);
            let totalHeight = thumbstripFrames * THUMBSTRIP_HEIGHT;

            // Prevent huge canvas
            if (totalHeight > MAX_CANVAS_HEIGHT) {
                thumbstripFrames = Math.ceil(MAX_CANVAS_HEIGHT / THUMBSTRIP_HEIGHT);
                totalHeight = thumbstripFrames * THUMBSTRIP_HEIGHT;
            }

            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = THUMBSTRIP_WIDTH;
            canvas.height = totalHeight;

            let currentFrame = 0;
            const frameInterval = duration / thumbstripFrames;

            const captureFrame = () => {
                video.currentTime = currentFrame * frameInterval;
                video.onseeked = () => {
                    ctx.drawImage(
                        video,
                        0,
                        currentFrame * THUMBSTRIP_HEIGHT,
                        THUMBSTRIP_WIDTH,
                        THUMBSTRIP_HEIGHT
                    );
                    currentFrame++;
                    if (currentFrame < thumbstripFrames) {
                        captureFrame();
                    } else {
                        canvas.toBlob((blob) => {
                            resolve(URL.createObjectURL(blob));
                        }, "image/png");
                    }
                };
            };

            captureFrame();
        };

        video.onerror = reject;
    });
};
